import { OnEvent, Service } from '@toeverything/infra';

import { UserApiKeysMode } from '../entities/user-api-keys-mode';
import { AccountChanged } from '../events/account-changed';

/**
 * Service for managing User API Keys Mode.
 *
 * Provides access to:
 * - Current AI mode (standard/user-keys)
 * - Keys configuration status
 * - Mode switching
 * - OpenAI key management
 */
@OnEvent(AccountChanged, e => e.onAccountChanged)
export class UserApiKeysModeService extends Service {
  userApiKeysMode = this.framework.createEntity(UserApiKeysMode);

  private onAccountChanged() {
    this.userApiKeysMode.revalidate();
  }
}
